"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.heading.chat': '开始与您的AI助手对话',
    'chat.heading.ask': '提出您的问题',
};
